export default {
    setLanguage(state, languageCode) {
        state.currentLanguage = languageCode;
    },
    setAvailableLanguages(state, languages) {
        state.availableLanguages = languages;
    }
};

